// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__xLjvn","loaderClass":"button_loaderClass__wm0XU"};